import { Controller } from "@hotwired/stimulus"

import { formNetMinutes } from "../utils/timesheet_net_time"

// A duration limit (WorkTimeModel#duration_limits) whose action is "explain" lets
// the employee book past the limit, but only with a written reason — see
// Timesheet::WorkTimeRuleChecker. This controller surfaces the hint next to the
// reason field as soon as the entered times cross the limit.
//
// The field itself is always rendered while such a rule applies (the form forces
// it even on a template that hides it), so there is no wrapper to toggle here —
// only the hint. That is deliberate: pool_site_controller may be toggling the
// very same notes wrapper, and two controllers fighting over one `hidden` class
// is a bug waiting to happen.
//
// Same contract as pool_site_controller otherwise: the server validates
// regardless. Note it checks the DAY TOTAL — this entry plus every other entry
// already booked for that employee and day — which the browser cannot see, so
// the hint is a best effort on the entered window(s).
export default class extends Controller {
  static targets = ["maxHint", "minHint"]
  // Only the side whose action is "explain" carries a value.
  static values = {
    minHours: Number,
    maxHours: Number,
  }

  connect() {
    this._form = this.element.closest("form") || this.element

    // break_periods_total_controller recomputes time_break and dispatches
    // synthetic input/change events, and multi_entry_controller clones whole
    // entry blocks — listening on the form catches both.
    this._handleChange = (event) => {
      const name = event.target?.name || ""
      if (name.includes("time_from") || name.includes("time_to") || name.includes("time_break")) {
        this.sync()
      }
    }
    this._form.addEventListener("change", this._handleChange)
    this._form.addEventListener("input", this._handleChange)

    // Let the time-input controllers write their hidden fields first.
    setTimeout(() => this.sync(), 150)
  }

  disconnect() {
    this._form.removeEventListener("change", this._handleChange)
    this._form.removeEventListener("input", this._handleChange)
  }

  sync() {
    const netHours = this.netMinutes() / 60
    const overMax = this.hasMaxHoursValue && this.maxHoursValue > 0 && netHours > this.maxHoursValue
    // An empty form is not "below the minimum" — it has nothing entered yet.
    const underMin =
      this.hasMinHoursValue &&
      this.minHoursValue > 0 &&
      netHours > 0 &&
      netHours < this.minHoursValue

    if (this.hasMaxHintTarget) this.maxHintTarget.classList.toggle("hidden", !overMax)
    if (this.hasMinHintTarget) this.minHintTarget.classList.toggle("hidden", !underMin)
  }

  netMinutes() {
    return formNetMinutes(this._form)
  }
}
